<template>
  <v-container>
    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="primary"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
    <v-sheet
      color="white"
      elevation="5"
      rounded
      class="mt-5 mb-5 pt-3 pb-5 pl-3 pr-3"
    >
      <h1>
        <slot name="title"></slot>
      </h1>
      <div v-if="!isLoading && !foundRequest">Request not found.</div>
      <div v-if="!isLoading && !!foundRequest">
        <div>
          <span>
            <b>Date Submitted:</b>
            <localized-date-time :instant="myRequest.submittedAt" /> </span
          ><br />
          <span> <b>Request Status: </b> {{ myRequest.status }} </span><br />
          <span v-if="myRequest.needsPaymentAuthorization">
            <b>Payment Authorization Status: </b>
            <v-tooltip dark right>
              <template v-slot:activator="{ on, attrs }">
                <font-awesome-icon
                  icon="credit-card"
                  :color="myRequest.paymentAuthorized ? 'green' : 'red'"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <span>{{
                myRequest.paymentAuthorized
                  ? "Authorized"
                  : "Authorization Rejected"
              }}</span> </v-tooltip
            ><br />
          </span>
          <span>
            <b>Payment Status: </b>
            <v-tooltip dark right>
              <template v-slot:activator="{ on, attrs }">
                <font-awesome-icon
                  icon="credit-card"
                  :color="myRequest.paymentCaptured ? 'green' : 'red'"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <span>{{ myRequest.paymentCaptured ? "Paid" : "Not paid" }}</span>
            </v-tooltip> </span
          ><br />
        </div>
        <div class="mt-5">
          <h3>Signatories</h3>
          <p>
            <v-simple-table
              fixed-header
              :height="
                myRequest && myRequest.signatories
                  ? Math.min(200, (myRequest.signatories.length + 2) * 50)
                  : 200
              "
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Name</th>
                    <th class="text-left">Membership ID</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="coOwner in myRequest.signatories"
                    :key="coOwner.personId"
                  >
                    <td>{{ coOwner.firstName }} {{ coOwner.lastName }}</td>
                    <td>{{ coOwner.memberId }}</td>
                    <td>
                      <v-tooltip dark right>
                        <template v-slot:activator="{ on, attrs }">
                          <font-awesome-icon
                            icon="signature"
                            :color="coOwner.signed ? 'green' : 'red'"
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <span>{{
                          coOwner.signed ? "Signed" : "Not signed"
                        }}</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </p>
        </div>
        <slot name="requestContent"></slot>
        <v-row class="ma-0 mt-5">
          <v-spacer />
          <hosted-registration-payment
            v-if="showPaymentAuthorizationStatus"
            :disabled="myRequest && !myRequest.needsPaymentAuthorization"
            buttonText="Authorize Payment"
            v-on:updatePaymentInfo="authorizePayment"
          />
          <hosted-registration-payment
            v-else-if="!useAuthorizedPayment || !myRequest.paymentAuthorized"
            :disabled="myRequest && !myRequest.needsPayment"
            v-on:updatePaymentInfo="makePayment"
          />
          <v-tooltip v-else dark bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="white--text"
                large
                color="primary"
                :disabled="myRequest && !myRequest.needsPayment"
                v-on:click="makePayment"
                v-bind="attrs"
                v-on="on"
              >
                Pay
              </v-btn>
            </template>
            <span>Will Charge your authorized card</span>
          </v-tooltip>
        </v-row>
      </div>
    </v-sheet>
  </v-container>
</template>

<script lang="ts">
import Vue from "vue";
import HostedRegistrationPayment from "@/components/common/HostedRegistrationPayment.vue";

import { UserInfo } from "@/types/User";
import { MyRequest } from "@/types/portal/Registration";

export default Vue.extend({
  name: "MyRequestLayout",
  components: { HostedRegistrationPayment },
  props: {
    foundRequest: { type: Boolean },
    isLoading: { type: Boolean },
    myRequest: { type: Object as () => MyRequest },
    paymentStatus: { type: Object },
    useAuthorizedPayment: { type: Boolean },
    makePayment: { type: Function },
    authorizePayment: { type: Function },
    showPaymentAuthorizationStatus: { type: Boolean },
  },
  data: function () {
    return {};
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
});
</script>
